/*
 * A&K 10.000
 * Author: Rouven Pajewski
 * Company: ActiView GmbH
 *
 * http://www.actiview.de
 */

$(document).ready(function() {
    var $window = $(window);

    // Kategorie - Titel wird dynamisch getauscht für Markenschops
    var categoryId = 432;

    $('.navi-all').each(function() {
        if ($(this).closest('.categorytree').find('.panel').data('cat-id') === categoryId) {
            $(this).find('a').text('zur Übersicht');
        }
    });

    $('[data-scroll-to]').click(function() {
        $('html, body').animate({
            scrollTop: $('[data-scroll-target="' + $(this).data('scroll-to') + '"]').offset().top
        }, 1000);
    });

    if ($('.paypal-installment-specific-promotion').length) {
        var $content = $('.paypal-installment-specific-promotion').clone();
  
        if ($content.find('b:first').length) {
            $('.paypal-installment-specific-promotion').html('<div class="ratenkauf-top"></div><div class="ratenkauf-bottom" style="display: none"></div>');

            $('.ratenkauf-top').html('<b>' + $content.find('b:first').html() + '</b><div class="btn av-btn av-btn-white av-btn-medium ratenkauf-toggle"><i class="fa fa-chevron-down"></i></div>');

            $('.ratenkauf-bottom').html($content.html());
        } else {
            $('.ratenkauf').hide();
        }
    }

    $(document).on('click', '.ratenkauf-toggle', function() {
        $('.ratenkauf-bottom').toggle();
    });
});
